// extracted by mini-css-extract-plugin
export default {"root":"UBQ9a","divider":"Q3orz","text":"E_2HP"};